// Converte serial do Excel para YYYY-MM-DD
function parseExcelDateToYYYYMMDD(serial) {
    if (!serial) return null;
    if (isNaN(serial)) {
        // Se vier como string (ex: '02/06/2026 22:59'), tenta extrair
        if (typeof serial === 'string') {
            const match = serial.match(/(\d{2})\/(\d{2})\/(\d{4})/);
            if (match) {
                return `${match[3]}-${match[2]}-${match[1]}`;
            }
            // Se já vier em YYYY-MM-DD (raro mas possível)
            if (/^\d{4}-\d{2}-\d{2}/.test(serial)) {
                return serial.substring(0, 10);
            }
        }
        return String(serial).trim();
    }
    
    // Tratamento padrão de data serial do Excel
    const utc_days  = Math.floor(serial - 25569);
    const utc_value = utc_days * 86400;                                        
    const date_info = new Date(utc_value * 1000);
    
    const d = String(date_info.getUTCDate()).padStart(2, '0');
    const m = String(date_info.getUTCMonth() + 1).padStart(2, '0');
    const y = date_info.getUTCFullYear();
    
    return `${y}-${m}-${d}`;
}

export const detectar = (dadosArray) => {
    // Procura na matriz (geralmente nas primeiras 20 linhas) se existem as colunas principais
    for (let i = 0; i < Math.min(20, dadosArray.length); i++) {
        const row = dadosArray[i];
        if (!row || !Array.isArray(row)) continue;
        
        const rowStr = row.map(c => String(c).toLowerCase().trim());
        
        if (rowStr.includes('data de criação') && 
            rowStr.includes('total do pedido') && 
            rowStr.includes('status')) {
            return true;
        }
    }
    return false;
};

export const processar = (dadosArray) => {
    let headerIndex = -1;
    let headers = [];

    // Localizar cabeçalhos
    for (let i = 0; i < Math.min(20, dadosArray.length); i++) {
        const row = dadosArray[i];
        if (!row || !Array.isArray(row)) continue;
        
        const rowStr = row.map(c => String(c).toLowerCase().trim());
        if (rowStr.includes('data de criação') && rowStr.includes('total do pedido')) {
            headerIndex = i;
            headers = rowStr;
            break;
        }
    }

    if (headerIndex === -1) {
        throw new Error('Cabeçalhos não encontrados no arquivo do Cardápio Web.');
    }

    const dateIdx = headers.indexOf('data de criação');
    const valIdx = headers.indexOf('total do pedido');
    const statusIdx = headers.indexOf('status');
    const metPagtoIdx = headers.indexOf('método de pagamento'); // Opcional

    const vendas = [];

    // Processar dados (abaixo do cabeçalho)
    for (let i = headerIndex + 1; i < dadosArray.length; i++) {
        const row = dadosArray[i];
        if (!row || row.length === 0) continue;

        const rawStatus = row[statusIdx] !== undefined ? String(row[statusIdx]).trim().toLowerCase() : '';
        const rawValor = row[valIdx];
        const rawData = row[dateIdx];
        
        // Ignorar linhas vazias
        if (rawData === undefined && rawValor === undefined) continue;
        if (rawData === '' && rawValor === '') continue;

        // Regra 1: Ignorar Cancelados
        if (rawStatus === 'cancelado' || rawStatus === 'cancelada') {
            continue;
        }

        let valorNum = 0;
        if (typeof rawValor === 'number') {
            valorNum = rawValor;
        } else if (typeof rawValor === 'string') {
            valorNum = parseFloat(rawValor.replace('R$', '').replace(/\./g, '').replace(',', '.').trim());
        }

        // Regra 2: Ignorar valor zero ou negativo (e erros de parse)
        if (isNaN(valorNum) || valorNum <= 0) {
            continue;
        }

        // Regra 3: Formatar data e remover horário (parseExcelDateToYYYYMMDD já faz isso)
        const dataFormatada = parseExcelDateToYYYYMMDD(rawData);

        vendas.push({
            linha: i + 1,
            data: dataFormatada,
            valor: valorNum,
            formaPagamento: metPagtoIdx !== -1 && row[metPagtoIdx] ? String(row[metPagtoIdx]).trim() : '',
            bandeira: metPagtoIdx !== -1 && row[metPagtoIdx] ? String(row[metPagtoIdx]).trim() : '',
            status: row[statusIdx] ? String(row[statusIdx]).trim() : 'Concluído'
        });
    }

    return vendas;
};
